<template>
  <Tag
    v-if="regenerating"
    severity="warning"
    value="Regenerating..."
    class="regenerating-tag"
  />
  <Tag v-else-if="justRegenerated" severity="success" value="Regenerated" />
  <Button
    v-else
    icon="pi pi-refresh"
    text
    rounded
    size="small"
    aria-label="Regenerate Snippet"
    v-tooltip.bottom="'Regenerate Snippet'"
    :loading="loading"
    @click="$emit('regenerate')"
  />
</template>

<script setup>
import Tag from "primevue/tag";
import Button from "primevue/button";

defineProps({
  regenerating: { type: Boolean, default: false },
  justRegenerated: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
});

defineEmits(["regenerate"]);
</script>

<style scoped>
.regenerating-tag {
  animation: regenerating-pulse 1.2s ease-in-out infinite;
}

@keyframes regenerating-pulse {
  50% {
    opacity: 0.4;
  }
}
</style>
